import styled from '@emotion/styled'

export const L1CodeGel = styled.div(({theme}) => ({
	boxSizing: 'border-box',
	width: theme.spacing(9.5),
	padding: theme.spacing(1),
	fontSize: '16px',
	fontWeight: 'bold',
	backgroundColor: theme.colors.second,
	color: theme.colors.inputLabel,
	borderRadius: theme.borderRadius,
	textAlign: 'center',
}))

export const L1AcceptedCodeGel = styled(L1CodeGel)(({theme}) => ({
	backgroundColor: theme.colors.blueLight1,
	color: theme.colors.white,
}))

export const L1ErrorCodeGel = styled(L1CodeGel)(({theme}) => ({
	backgroundColor: theme.colors.errorRed,
	color: theme.colors.stopRed,
}))
